import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsModalDiagramCreateEnabled, selectModalDiagramCreateData } from '../../../redux/main/main.selectors';
import { toggleDiagramCreate, toggleDiagramCreateNew } from '../../../redux/main/main.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';

import './ModalDiagramCreate.scss';

export const ModalDiagramCreate = () => {
    const history = useHistory();

    const isOpen = useSelector(selectIsModalDiagramCreateEnabled);
    const modalData = useSelector(selectModalDiagramCreateData);

    const [page, setPage] = useState('');

    const inputRef = useRef(null);

    const dispatch = useDispatch();

    const [selectedDb, setSelectedDb] = useState(null);


    useEffect(() => {
        if (!modalData?.page) return;
        setPage(modalData?.page);

        return () => { };
    }, [modalData]);

    const handleCancel = () => {
        dispatch(toggleDiagramCreate(null));
        setTimeout(() => {
            setSelectedDb(null);
        }, 200);
    };

    const handleCloneTemplateCancel = () => {
        setTimeout(() => {
            setSelectedDb(null);
        }, 50);
    };

    const handleCloneTemplateSelectDb = (item = null) => {
        setTimeout(() => {
            setSelectedDb(item);
        }, 50);
    };

    const handleCloneTemplateCreate = () => {
        dispatch(toggleDiagramCreate(null));
        setTimeout(() => {
            setSelectedDb(null);
        }, 200);
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleOpenBrowseTemplate = () => {
        dispatch(toggleDiagramCreate(null));
        const url = `/templates`;
        setTimeout(() => {
            history.push(url);
            setSelectedDb(null);
        }, 200);
    };

    const handleOpenPlayground = () => {
        window.open(`https://playground.dbdesign.io`, '_blank');
        // window.open(`http://localhost:3000/d/019737c9-30c7-757f-8a2b-81e30b3c212e/`, '_blank');
        setSelectedDb(null);
    };

    const handleNewProject = () => {
        trackEvent('app_modal_diagram_create_new', {
            page: 'app',
            type: 'modals',
        });
        dispatch(toggleDiagramCreate(null));
        setTimeout(() => {
            dispatch(toggleDiagramCreateNew(page));
            setSelectedDb(null);
        }, 150);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-create ${page}`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{`Let's build something new`}</div>
            <div className="modal-content-body">

                <div className='section-group'>
                    <div className='section-group-item'>
                        <div className='section-group-item-title'>Create Diagram</div>
                        <div className='left-group'>
                            <button className='left-group-item import prime' onClick={() => handleNewProject()}>
                                {/* <svg className='plus' width="17" height="19" viewBox="0 0 20 20"><g><path fillRule="evenodd" d="M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z"></path></g></svg> */}
                                {/* <svg className="plus" width="24" height="24" viewBox="0 0 20 20"><g><path fillRule="evenodd" strokeWidth="0px" d="M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z"></path></g></svg> */}
                                New Diagram
                            </button>
                            <button className='left-group-item import'>
                                Import from SQL
                            </button>
                            <button className='left-group-item import'>
                                Import from DBML
                            </button>
                            <button className='left-group-item import'>
                                Clone Template
                            </button>
                        </div>
                    </div>
                    {/* <div className='section-group-item'>
                        <div className='section-group-item-title'>Clone Template</div>
                        <div className='left-group right'>
                            <div className='right-group'>
                                <div className={`left-group-item import ${selectedDb === 'mysql' ? 'selected' : ''}`} onClick={() => handleCloneTemplateSelectDb('mysql')}>
                                    <div className='template-pointer'>
                                        <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                d="M9.53033 2.21968L9 1.68935L7.93934 2.75001L8.46967 3.28034L12.4393 7.25001H1.75H1V8.75001H1.75H12.4393L8.46967 12.7197L7.93934 13.25L9 14.3107L9.53033 13.7803L14.6036 8.70711C14.9941 8.31659 14.9941 7.68342 14.6036 7.2929L9.53033 2.21968Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </div>

                                    MySQL
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'postgresql' ? 'selected' : ''}`} onClick={() => handleCloneTemplateSelectDb('postgresql')}>
                                    <div className='template-pointer'>
                                        <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                d="M9.53033 2.21968L9 1.68935L7.93934 2.75001L8.46967 3.28034L12.4393 7.25001H1.75H1V8.75001H1.75H12.4393L8.46967 12.7197L7.93934 13.25L9 14.3107L9.53033 13.7803L14.6036 8.70711C14.9941 8.31659 14.9941 7.68342 14.6036 7.2929L9.53033 2.21968Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </div>

                                    PostgreSQL
                                </div>
                            </div>
                            <div className='right-group'>
                                <div className={`left-group-item import ${selectedDb === 'sqlserver' ? 'selected' : ''}`} onClick={() => handleCloneTemplateSelectDb('sqlserver')}>
                                    SQL Server
                                    <div className='template-pointer'>
                                        <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                d="M9.53033 2.21968L9 1.68935L7.93934 2.75001L8.46967 3.28034L12.4393 7.25001H1.75H1V8.75001H1.75H12.4393L8.46967 12.7197L7.93934 13.25L9 14.3107L9.53033 13.7803L14.6036 8.70711C14.9941 8.31659 14.9941 7.68342 14.6036 7.2929L9.53033 2.21968Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'oracle' ? 'selected' : ''}`} onClick={() => handleCloneTemplateSelectDb('oracle')}>
                                    <div className='template-pointer'>
                                        <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                d="M9.53033 2.21968L9 1.68935L7.93934 2.75001L8.46967 3.28034L12.4393 7.25001H1.75H1V8.75001H1.75H12.4393L8.46967 12.7197L7.93934 13.25L9 14.3107L9.53033 13.7803L14.6036 8.70711C14.9941 8.31659 14.9941 7.68342 14.6036 7.2929L9.53033 2.21968Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </div>
                                    Oracle
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

                {/* {
                    !selectedDb
                        ?
                        <div className='buttons-section'>
                            <button className='button-second' onClick={() => handleOpenPlayground()}>Open Playground</button>
                            <button onClick={() => handleOpenBrowseTemplate()}>Browse All Templates</button>
                        </div>
                        :
                        <div className='buttons-section buttons-section-full'>
                            <div className='buttons-section'>
                            </div>
                            <div className='buttons-section'>
                                <button className='button-second' onClick={() => handleCloneTemplateCancel()}>Cancel</button>
                                <button onClick={() => handleCloneTemplateCreate()}>Create Diagram</button>
                            </div>
                        </div>
                } */}
            </div>

            {/* <input
                    autoComplete="off"
                    ref={inputRef}
                    spellCheck="false"
                    type="text"
                    id="board-name"
                    placeholder="Enter diagram name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <button>Create</button>
                <button className='button-second'>Cancel</button>
            </div> */}
        </Modal>
    );
};

export default ModalDiagramCreate;





// - modal create BASE
// - modal create new

// - modal create import sql/dbml (not selected)
// - modal create clone template (selected boilerplate)


// - modal import sql/dbml (selected)
// - modal clone template (not selected)
